<template>
  <div  style="padding: 10px">
    <el-form ref="form" :model="form" label-width="120px" size="small">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基础信息</span>
        </div>
<!--        <slot name="form-item-transition-name" :model="form" field="name">-->
<!--          <el-form-item label="名称">-->
<!--            <el-input v-model="form.name"></el-input>-->
<!--          </el-form-item>-->
<!--        </slot>-->
        <slot name="form-item-transition-displayName" :model="form" field="displayName">
          <el-form-item label="显示名称">
            <el-input v-model="form.displayName"></el-input>
          </el-form-item>
        </slot>
        <slot name="form-item-transition-expr" :model="form" field="expr">
          <el-form-item label="表达式">
            <el-input v-model="form.expr"></el-input>
          </el-form-item>
        </slot>
      </el-card>

    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      form: this.value
    }
  },
  watch: {
    form: {
      handler (n) {
        this.$emit('change', n)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.box-card{
  border-radius: 8px;
  margin-bottom: 20px;
}
.clearfix{
  font-size: 16px;
  font-weight: bold;
}
</style>
